import classNames from 'classnames'
import Icon from '@components/Icon'
import { getPinIcon, getPOIIcon } from 'map/helpers'
import styles from './styles.module.scss'

const Pin = ({ theme, name = '', hovered, faded, active, bookable, children, small, onClick, type }) => (
    <div
        onClick={onClick}
        title={name}
        className={classNames(styles.pin, {
            [styles.hovered]: hovered || active,
        })}>
        <Icon className={styles.icon} type={type ? getPOIIcon(type) : getPinIcon({ theme, faded, active, bookable })} />
        {bookable && (
            <div
                className={classNames(styles.rate, {
                    [styles.small]: small,
                })}>
                {children}
            </div>
        )}
    </div>
)

export default Pin
